import React, { useState } from 'react';

import { StyledPageMenuLink } from './PageMenuLink.styles';

import { PageMenuLinkProps } from './PageMenuLink.types';

const PageMenuLink = ({
  linkList,
  defaultActiveSlotIndex = 0,
  renderLink,
  onChangeActiveSlot = () => {},
  componentClassname = 'page-menu-link',
  customClassnames = '',
  customStyle = '',
  ...props
}: PageMenuLinkProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(
    defaultActiveSlotIndex,
  );

  const handleChangeActiveIndex = (index: number) => {
    setActiveIndex(index);
    onChangeActiveSlot(index);
  };
  return (
    <StyledPageMenuLink
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {linkList?.map((link, index) => (
        <div
          key={index}
          onClick={() => handleChangeActiveIndex(index)}
          className={`${componentClassname}__link-item ${
            activeIndex === index
              ? `${componentClassname}__link-item--is-active`
              : ''
          } ${
            linkList.length === index + 1
              ? `${componentClassname}__link-item--is-last`
              : ''
          }`}
        >
          {link.href &&
            (renderLink ? (
              renderLink({
                href: link.href,
                children: link.content,
                additionalParams: {
                  className: `${componentClassname}__link`,
                },
              })
            ) : (
              <a href={link.href} className={`${componentClassname}__link`}>
                {link.content}
              </a>
            ))}

          {!link.href && (
            <div className={`${componentClassname}__not-a-link`}>
              {link.content}
            </div>
          )}
        </div>
      ))}
    </StyledPageMenuLink>
  );
};
PageMenuLink.displayName = 'PageMenuLink';

export default PageMenuLink;
